import '../../assets/index47.css';var We = Object.defineProperty, Ge = Object.defineProperties;
var Je = Object.getOwnPropertyDescriptors;
var J = Object.getOwnPropertySymbols;
var Se = Object.prototype.hasOwnProperty, ve = Object.prototype.propertyIsEnumerable;
var Ce = (t, r, o) => r in t ? We(t, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[r] = o, m = (t, r) => {
  for (var o in r || (r = {}))
    Se.call(r, o) && Ce(t, o, r[o]);
  if (J)
    for (var o of J(r))
      ve.call(r, o) && Ce(t, o, r[o]);
  return t;
}, P = (t, r) => Ge(t, Je(r));
var E = (t, r) => {
  var o = {};
  for (var i in t)
    Se.call(t, i) && r.indexOf(i) < 0 && (o[i] = t[i]);
  if (t != null && J)
    for (var i of J(t))
      r.indexOf(i) < 0 && ve.call(t, i) && (o[i] = t[i]);
  return o;
};
import { jsx as a, jsxs as f, Fragment as qe } from "react/jsx-runtime";
import { Pagination as Ue } from "../Pagination/index.js";
import { Stack as ke } from "../Stack/index.js";
import { Flex as q } from "../Flex/index.js";
import { Text as ae } from "../Text/index.js";
import { useState as D, useRef as we, useEffect as Ye, useLayoutEffect as Ze, useMemo as Qe } from "react";
import { Button as U } from "../Button/index.js";
import { TextField as Ke } from "../TextField/index.js";
import { Menu as le } from "../Menu/index.js";
import { T as xe } from "../../index-eVpm_et2.js";
import { Checkbox as Fe } from "../Checkbox/index.js";
import { DismissibleTag as et } from "../DismissibleTag/index.js";
import { ArrowDownFarFAIcon as tt, ArrowUpFarFAIcon as rt, FilterFarFAIcon as at, XMarkFarFAIcon as lt } from "../Icons/index.js";
import { r as ne } from "../../rem-CMQJ_ZTp.js";
import { b as Ne } from "../../get-size-Bc1Pz5yf.js";
import { c as Pe } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as ie, u as ce, B as de, h as oe } from "../../factory-ueRxoNOV.js";
import { u as ze } from "../../use-styles-DToiHEa6.js";
import { c as ot } from "../../create-safe-context-DqDyoPVE.js";
import { S as nt } from "../../ScrollArea-BFbb1tLv.js";
const [st, it] = ot(
  "Table component was not found in the tree"
);
var X = { table: "m_b23fa0ef", th: "m_4e7aa4f3", tr: "m_4e7aa4fd", td: "m_4e7aa4ef", tbody: "m_b2404537", thead: "m_b242d975", caption: "m_9e5a3ac7", scrollContainer: "m_a100c15", scrollContainerInner: "m_62259741" };
function ct(t, r) {
  if (!r)
    return;
  const o = {};
  return r.columnBorder && t.withColumnBorders && (o["data-with-column-border"] = !0), r.rowBorder && t.withRowBorders && (o["data-with-row-border"] = !0), r.striped && t.striped && (o["data-striped"] = t.striped), r.highlightOnHover && t.highlightOnHover && (o["data-hover"] = !0), r.captionSide && t.captionSide && (o["data-side"] = t.captionSide), r.stickyHeader && t.stickyHeader && (o["data-sticky"] = !0), o;
}
function L(t, r) {
  const o = `Table${t.charAt(0).toUpperCase()}${t.slice(1)}`, i = ie((T, y) => {
    const C = ce(o, {}, T), p = C, { classNames: v, className: w, style: F, styles: N } = p, S = E(p, ["classNames", "className", "style", "styles"]), b = it();
    return /* @__PURE__ */ a(
      de,
      m(m(m({
        component: t,
        ref: y
      }, ct(b, r)), b.getStyles(t, { className: w, classNames: v, style: F, styles: N, props: C })), S)
    );
  });
  return i.displayName = `@mantine/core/${o}`, i.classes = X, i;
}
const se = L("th", { columnBorder: !0 }), Ae = L("td", { columnBorder: !0 }), Y = L("tr", {
  rowBorder: !0,
  striped: !0,
  highlightOnHover: !0
}), $e = L("thead", { stickyHeader: !0 }), Ie = L("tbody"), De = L("tfoot"), Le = L("caption", { captionSide: !0 });
function he({ data: t }) {
  return /* @__PURE__ */ f(qe, { children: [
    t.caption && /* @__PURE__ */ a(Le, { children: t.caption }),
    t.head && /* @__PURE__ */ a($e, { children: /* @__PURE__ */ a(Y, { children: t.head.map((r, o) => /* @__PURE__ */ a(se, { children: r }, o)) }) }),
    t.body && /* @__PURE__ */ a(Ie, { children: t.body.map((r, o) => /* @__PURE__ */ a(Y, { children: r.map((i, T) => /* @__PURE__ */ a(Ae, { children: i }, T)) }, o)) }),
    t.foot && /* @__PURE__ */ a(De, { children: /* @__PURE__ */ a(Y, { children: t.foot.map((r, o) => /* @__PURE__ */ a(se, { children: r }, o)) }) })
  ] });
}
he.displayName = "@mantine/core/TableDataRenderer";
const dt = {
  type: "scrollarea"
}, ht = Pe(
  (t, { minWidth: r, maxHeight: o, type: i }) => ({
    scrollContainer: {
      "--table-min-width": ne(r),
      "--table-max-height": ne(o),
      "--table-overflow": i === "native" ? "auto" : void 0
    }
  })
), me = ie((t, r) => {
  const o = ce("TableScrollContainer", dt, t), B = o, {
    classNames: i,
    className: T,
    style: y,
    styles: C,
    unstyled: v,
    vars: w,
    children: F,
    minWidth: N,
    maxHeight: S,
    type: b,
    scrollAreaProps: p
  } = B, x = E(B, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "children",
    "minWidth",
    "maxHeight",
    "type",
    "scrollAreaProps"
  ]), O = ze({
    name: "TableScrollContainer",
    classes: X,
    props: o,
    className: T,
    style: y,
    classNames: i,
    styles: C,
    unstyled: v,
    vars: w,
    varsResolver: ht,
    rootSelector: "scrollContainer"
  });
  return /* @__PURE__ */ a(
    de,
    P(m(m(P(m({
      component: b === "scrollarea" ? nt : "div"
    }, b === "scrollarea" ? m(S ? { offsetScrollbars: "xy" } : { offsetScrollbars: "x" }, p) : {}), {
      ref: r
    }), O("scrollContainer")), x), {
      children: /* @__PURE__ */ a("div", P(m({}, O("scrollContainerInner")), { children: F }))
    })
  );
});
me.classes = X;
me.displayName = "@mantine/core/TableScrollContainer";
const mt = {
  withRowBorders: !0,
  verticalSpacing: 7
}, bt = Pe(
  (t, {
    layout: r,
    captionSide: o,
    horizontalSpacing: i,
    verticalSpacing: T,
    borderColor: y,
    stripedColor: C,
    highlightOnHoverColor: v,
    striped: w,
    highlightOnHover: F,
    stickyHeaderOffset: N,
    stickyHeader: S
  }) => ({
    table: {
      "--table-layout": r,
      "--table-caption-side": o,
      "--table-horizontal-spacing": Ne(i),
      "--table-vertical-spacing": Ne(T),
      "--table-border-color": y ? oe(y, t) : void 0,
      "--table-striped-color": w && C ? oe(C, t) : void 0,
      "--table-highlight-on-hover-color": F && v ? oe(v, t) : void 0,
      "--table-sticky-header-offset": S ? ne(N) : void 0
    }
  })
), c = ie((t, r) => {
  const o = ce("Table", mt, t), M = o, {
    classNames: i,
    className: T,
    style: y,
    styles: C,
    unstyled: v,
    vars: w,
    horizontalSpacing: F,
    verticalSpacing: N,
    captionSide: S,
    stripedColor: b,
    highlightOnHoverColor: p,
    striped: x,
    highlightOnHover: O,
    withColumnBorders: B,
    withRowBorders: Z,
    withTableBorder: be,
    borderColor: Q,
    layout: K,
    variant: H,
    data: z,
    children: ee,
    stickyHeader: k,
    stickyHeaderOffset: ue,
    mod: A,
    tabularNums: V
  } = M, u = E(M, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "horizontalSpacing",
    "verticalSpacing",
    "captionSide",
    "stripedColor",
    "highlightOnHoverColor",
    "striped",
    "highlightOnHover",
    "withColumnBorders",
    "withRowBorders",
    "withTableBorder",
    "borderColor",
    "layout",
    "variant",
    "data",
    "children",
    "stickyHeader",
    "stickyHeaderOffset",
    "mod",
    "tabularNums"
  ]), $ = ze({
    name: "Table",
    props: o,
    className: T,
    style: y,
    classes: X,
    classNames: i,
    styles: C,
    unstyled: v,
    rootSelector: "table",
    vars: w,
    varsResolver: bt
  });
  return /* @__PURE__ */ a(
    st,
    {
      value: {
        getStyles: $,
        stickyHeader: k,
        striped: x === !0 ? "odd" : x || void 0,
        highlightOnHover: O,
        withColumnBorders: B,
        withRowBorders: Z,
        captionSide: S || "bottom"
      },
      children: /* @__PURE__ */ a(
        de,
        P(m(m({
          component: "table",
          variant: H,
          ref: r,
          mod: [{ "data-with-table-border": be, "data-tabular-nums": V }, A]
        }, $("table")), u), {
          children: ee || !!z && /* @__PURE__ */ a(he, { data: z })
        })
      )
    }
  );
});
c.classes = X;
c.displayName = "@mantine/core/Table";
c.Td = Ae;
c.Th = se;
c.Tr = Y;
c.Thead = $e;
c.Tbody = Ie;
c.Tfoot = De;
c.Caption = Le;
c.ScrollContainer = me;
c.DataRenderer = he;
const ut = "Table-module__root___5X62v", pt = "Table-module__tableWrapper___voR20", _t = "Table-module__table___VzDyA", ft = "Table-module__thead___n9aOA", gt = "Table-module__th___tq0gm", Tt = "Table-module__tableCheckbox___Gt8qi", yt = "Table-module__td___Js8My", Ct = "Table-module__tr___VNlrk", St = "Table-module__tbody___5LXib", vt = "Table-module__fixedColumn___vqaAC", kt = "Table-module__columnSizeXs___3IYGB", wt = "Table-module__columnSizeSm___jwj2y", xt = "Table-module__columnSizeMd___r6fY4", Ft = "Table-module__columnSizeLg___wHLLt", Nt = "Table-module__columnSizeXl___nejJ-", Pt = "Table-module__columnSizeXxl___wIPEO", zt = "Table-module__sortIcon___573RG", At = "Table-module__tableColumnAdjustment___AuboD", $t = "Table-module__cellContent___1JBZF", It = "Table-module__fixedColumnShadow___-kAhx", Dt = "Table-module__activeFilter___-r-fs", Lt = "Table-module__filterDropdown___gaD1E", Ot = "Table-module__headerOptions___FovIA", Bt = "Table-module__selectColumn___G3JkL", Ht = "Table-module__tableCounter___4LN-0", h = {
  root: ut,
  tableWrapper: pt,
  table: _t,
  thead: ft,
  th: gt,
  tableCheckbox: Tt,
  td: yt,
  tr: Ct,
  tbody: St,
  fixedColumn: vt,
  columnSizeXs: kt,
  columnSizeSm: wt,
  columnSizeMd: xt,
  columnSizeLg: Ft,
  columnSizeXl: Nt,
  columnSizeXxl: Pt,
  sortIcon: zt,
  tableColumnAdjustment: At,
  cellContent: $t,
  fixedColumnShadow: It,
  activeFilter: Dt,
  filterDropdown: Lt,
  headerOptions: Ot,
  selectColumn: Bt,
  tableCounter: Ht
}, sr = (be) => {
  var Q = be, {
    data: t,
    columns: r,
    loading: o,
    emptyMessage: i = "No data available",
    itemsPerPage: T = 10,
    withPagination: y = !1,
    withItemsPerPageSelector: C = !1,
    itemsPerPageOptions: v = [10, 25, 50, 100],
    className: w,
    filterable: F = !1,
    selectable: N = !1,
    selectedRows: S = [],
    idField: b = "id",
    onSelectionChange: p,
    onClickRow: x,
    withCounter: O = !1,
    paginationProps: B = {}
  } = Q, Z = E(Q, [
    "data",
    "columns",
    "loading",
    "emptyMessage",
    "itemsPerPage",
    "withPagination",
    "withItemsPerPageSelector",
    "itemsPerPageOptions",
    "className",
    "filterable",
    "selectable",
    "selectedRows",
    "idField",
    "onSelectionChange",
    "onClickRow",
    "withCounter",
    "paginationProps"
  ]);
  const [K, H] = D(1), [z, ee] = D(T), [k, ue] = D(null), [A, V] = D("asc"), [u, $] = D({}), [M, Oe] = D(null), [pe, Be] = D(!1), _ = we(S), W = we(null);
  Ye(() => {
    _.current = S;
  }, [S]);
  const _e = (e) => {
    const n = _.current.includes(e) ? _.current.filter((l) => l !== e) : [..._.current, e];
    _.current = n, p == null || p(n);
  }, fe = () => {
    const e = I.map((s) => s[b]), n = e.every((s) => _.current.includes(s));
    let l;
    if (n)
      l = _.current.filter((s) => !e.includes(s));
    else {
      const s = new Set(_.current);
      e.forEach((d) => s.add(d)), l = Array.from(s);
    }
    _.current = l, p == null || p(l);
  }, He = (e) => {
    ee(e), H(1);
  };
  Ze(() => {
    const e = () => {
      if (W.current) {
        const l = W.current.scrollLeft > 1;
        Be(l);
      }
    }, n = W.current;
    return n && (n.addEventListener("scroll", e), e()), () => {
      n && n.removeEventListener("scroll", e);
    };
  }, []);
  const je = (e) => {
    k === e ? V(A === "asc" ? "desc" : "asc") : (ue(e), V("asc"));
  }, ge = (e, n) => {
    const l = r.find((s) => s.key === e);
    $((s) => P(m({}, s), {
      [e]: n
    })), l != null && l.onFilter && l.onFilter(n), H(1);
  }, Me = (e, n) => {
    const l = r.find((s) => s.key === e);
    if ($((s) => {
      const d = s[e] ? s[e].split(",") : [], g = d.includes(n) ? d.filter((j) => j !== n) : [...d, n];
      return P(m({}, s), {
        [e]: g.length > 0 ? g.join(",") : ""
      });
    }), l != null && l.onFilter) {
      const s = u[e] ? u[e].split(",") : [], d = s.includes(n) ? s.filter((g) => g !== n) : [...s, n];
      l.onFilter(d.join(","));
    }
    H(1);
  }, Te = (e) => {
    Oe(M === e ? null : e);
  }, te = (e) => {
    const n = r.find((l) => l.key === e);
    $((l) => {
      const s = m({}, l);
      return delete s[e], s;
    }), n != null && n.onFilter && n.onFilter("");
  }, Re = () => {
    $({}), r.forEach((e) => {
      e.onFilter && u[e.key] && e.onFilter("");
    });
  }, G = () => Object.entries(u).filter(([e, n]) => n && n.trim() !== ""), R = Qe(() => {
    let e = [...t];
    return Object.keys(u).length > 0 && (e = e.filter((n) => Object.entries(u).every(([l, s]) => {
      if (!s) return !0;
      const d = r.find((j) => j.key === l);
      if (d != null && d.onFilter) return !0;
      const g = d != null && d.filterValue ? d.filterValue(n) : n[l];
      if (g === void 0) return !1;
      if (s.includes(",")) {
        const j = s.split(",").map((re) => re.trim().toLowerCase());
        return (d == null ? void 0 : d.filterMode) === "partial" ? j.some((re) => String(g).toLowerCase().includes(re)) : j.includes(String(g).toLowerCase());
      }
      return String(g).toLowerCase().includes(s.toLowerCase());
    }))), k && e.sort((n, l) => {
      const s = n[k], d = l[k];
      if (s === d) return 0;
      const g = typeof s == "string" ? s.localeCompare(d) : s - d;
      return A === "asc" ? g : -g;
    }), e;
  }, [t, u, k, A, r]), Ee = Math.ceil(R.length / z), ye = (K - 1) * z, Xe = ye + z, I = y ? R.slice(ye, Xe) : R, Ve = ({ content: e }) => /* @__PURE__ */ a(
    "div",
    {
      className: h.cellContent,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%"
      },
      children: e
    }
  );
  return /* @__PURE__ */ f(ke, { gap: "sm", className: w, children: [
    O && /* @__PURE__ */ f(q, { className: h.tableCounter, gap: "var(--plum-spacing-md)", pl: "var(--plum-spacing-xl)", py: "var(--plum-spacing-xxs)", align: "center", h: "var(--plum-spacing-xl)", children: [
      /* @__PURE__ */ f(ae, { size: "md", c: "gray.9", prominent: !0, children: [
        R.length,
        " ",
        "items"
      ] }),
      G().length > 0 && /* @__PURE__ */ f(q, { gap: "xs", align: "center", children: [
        /* @__PURE__ */ a(ae, { size: "lg", c: "gray.6", mr: "var(--plum-spacing-xs)", children: "•" }),
        /* @__PURE__ */ f(ae, { size: "md", c: "gray.7", children: [
          G().length === 1 ? "Filter" : "Filters",
          " ",
          "applied:"
        ] }),
        G().map(([e, n]) => {
          const l = r.find((s) => s.key === e);
          return /* @__PURE__ */ a(
            et,
            {
              onRemove: () => te(e),
              "data-plum-id": `filter-tag-${e}`,
              size: "lg",
              children: (l == null ? void 0 : l.header) || e
            },
            e
          );
        }),
        G().length > 1 && /* @__PURE__ */ a(
          U,
          {
            variant: "tertiary",
            onClick: () => Re(),
            "aria-label": "Clear all filters",
            danger: !0,
            children: "Clear all"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a("div", { className: h.tableWrapper, ref: W, children: /* @__PURE__ */ f(c, P(m({ classNames: h }, Z), { children: [
      /* @__PURE__ */ a(c.Thead, { className: h.thead, children: /* @__PURE__ */ f(c.Tr, { children: [
        N && /* @__PURE__ */ a(
          c.Th,
          {
            className: h.selectColumn,
            onClick: fe,
            style: { cursor: "pointer" },
            children: /* @__PURE__ */ a(
              Fe,
              {
                label: "",
                className: h.tableCheckbox,
                checked: I.length > 0 && I.every((e) => _.current.includes(e[b])),
                indeterminate: I.some((e) => _.current.includes(e[b])) && !I.every((e) => _.current.includes(e[b])),
                onChange: (e) => {
                  e.stopPropagation(), fe();
                },
                onClick: (e) => e.stopPropagation(),
                "aria-label": "Select all rows"
              }
            )
          }
        ),
        r.map((e) => /* @__PURE__ */ a(
          c.Th,
          {
            style: e.width ? { width: e.width } : void 0,
            className: `${e.className || ""} ${e.sortable ? h.sortableHeader : ""} ${e.filterable ? h.filterableHeader : ""} ${e.fixed ? `${h.fixedColumn} ${pe ? h.fixedColumnShadow : ""}` : ""} ${e.key in h ? h[e.key] : ""}`,
            children: /* @__PURE__ */ f(q, { align: "center", gap: "xxs", children: [
              /* @__PURE__ */ a("div", { className: h.headerContent, children: e.header }),
              /* @__PURE__ */ f(q, { className: h.headerOptions, children: [
                e.sortable && /* @__PURE__ */ a(xe, { label: k === e.key && A === "asc" ? "Sort descending" : "Sort ascending", children: /* @__PURE__ */ a(
                  U,
                  {
                    variant: "tertiary",
                    onClick: () => je(e.key),
                    className: k === e.key ? h.activeSort : "",
                    "aria-label": `Sort by ${e.header}`,
                    children: k === e.key && A === "desc" ? /* @__PURE__ */ a(tt, {}) : /* @__PURE__ */ a(rt, {})
                  }
                ) }),
                e.filterable && F && /* @__PURE__ */ f(
                  le,
                  {
                    opened: M === e.key,
                    onChange: () => Te(e.key),
                    position: "bottom-start",
                    closeOnClickOutside: !0,
                    closeOnEscape: !0,
                    children: [
                      /* @__PURE__ */ a(le.Target, { children: /* @__PURE__ */ a("div", { className: u[e.key] ? h.activeFilter : "", children: /* @__PURE__ */ a(xe, { label: `Filter ${e.header}`, children: /* @__PURE__ */ a(
                        U,
                        {
                          variant: "tertiary",
                          onClick: () => Te(e.key),
                          "aria-label": `Filter ${e.header}`,
                          children: /* @__PURE__ */ a(at, { filled: !!u[e.key] })
                        }
                      ) }) }) }),
                      /* @__PURE__ */ a(le.Dropdown, { className: h.filterDropdown, children: e.renderFilter ? e.renderFilter(
                        u[e.key] || "",
                        (n) => ge(e.key, n),
                        () => te(e.key),
                        (n) => Me(e.key, n)
                      ) : /* @__PURE__ */ f(ke, { gap: "xs", children: [
                        /* @__PURE__ */ a(
                          Ke,
                          {
                            w: "100%",
                            label: "Filter",
                            value: u[e.key] || "",
                            onChange: (n) => ge(e.key, n.target.value)
                          }
                        ),
                        u[e.key] && /* @__PURE__ */ a(
                          U,
                          {
                            variant: "tertiary",
                            onClick: () => te(e.key),
                            "aria-label": "Clear filter",
                            leftSection: /* @__PURE__ */ a(lt, {}),
                            danger: !0,
                            children: "Clear filter"
                          }
                        )
                      ] }) })
                    ]
                  }
                )
              ] })
            ] })
          },
          e.key
        ))
      ] }) }),
      /* @__PURE__ */ a(c.Tbody, { children: o ? /* @__PURE__ */ a(c.Tr, { children: /* @__PURE__ */ a(c.Td, { colSpan: r.length, align: "center", children: "Loading..." }) }) : I.length === 0 ? /* @__PURE__ */ a(c.Tr, { children: /* @__PURE__ */ a(c.Td, { colSpan: r.length, align: "center", children: i }) }) : I.map((e, n) => /* @__PURE__ */ f(
        c.Tr,
        {
          onClick: () => x == null ? void 0 : x(e),
          style: { cursor: x ? "pointer" : void 0 },
          children: [
            N && /* @__PURE__ */ a(
              c.Td,
              {
                className: h.selectColumn,
                onClick: (l) => {
                  l.stopPropagation(), _e(e[b]);
                },
                style: { cursor: "pointer" },
                children: /* @__PURE__ */ a(
                  Fe,
                  {
                    label: "",
                    className: h.tableCheckbox,
                    checked: _.current.includes(e[b]),
                    onChange: (l) => {
                      l.stopPropagation(), _e(e[b]);
                    },
                    onClick: (l) => l.stopPropagation(),
                    "aria-label": `Select row ${n + 1}`
                  }
                )
              }
            ),
            r.map((l, s) => /* @__PURE__ */ a(
              c.Td,
              {
                "data-cell-index": s,
                className: `${l.className || ""} ${l.fixed ? `${h.fixedColumn} ${pe ? h.fixedColumnShadow : ""}` : ""}`,
                children: l.render ? l.render(e) : /* @__PURE__ */ a(Ve, { content: String(e[l.key]) })
              },
              `${n}-${l.key}`
            ))
          ]
        },
        n
      )) })
    ] })) }),
    y && /* @__PURE__ */ a(
      Ue,
      m({
        total: Ee,
        value: K,
        onChange: H,
        withItemsPerPage: C,
        totalItems: R.length,
        itemsPerPage: z,
        itemsPerPageOptions: v,
        onItemsPerPageChange: He
      }, B)
    )
  ] });
};
export {
  sr as Table
};
